export default {
  specifications: [
    {
      id: 1,
      name: 'Number of independent channels',
      value: '2',
    },
    {
      id: 2,
      name: 'Frequency measurement range',
      value: '1.5…10 MHz',
    },
    {
      id: 3,
      name: 'Gain adjustment range',
      value: '0…84 dB with 1 dB step',
    },
    {
      id: 4,
      name: 'Dynamic range of time variable gain',
      value: 'up to 84 dB',
    },
    {
      id: 6,
      name: 'Flaw detection alarm',
      value: 'light and vibration (can be turned off)',
    },
    {
      id: 7,
      name: 'Pulse amplitude',
      value: '50…150 V',
    },
    {
      id: 8,
      name: 'Pulse repetition frequency ',
      value: '250 Hz',
    },
    {
      id: 9,
      name: 'Maximum depth (steel)',
      value: '2400 mm',
    },
    {
      id: 10,
      name: 'Material velocity',
      value: '1…12000 m/s',
    },
    {
      id: 11,
      name: 'Interfaces',
      value: 'WI-FI, Bluetooth, USB',
    },
    {
      id: 12,
      name: 'External devices',
      value: 'distance sensor, control buttons, etc.',
    },
    {
      id: 13,
      name: 'Battery',
      value: 'Li-ion built-in',
    },
    {
      id: 14,
      name: 'Battery life',
      value: 'minimum 6 hours',
    },
    {
      id: 15,
      name: 'Operating temperature',
      value: '-20°…+45°C',
    },
    {
      id: 16,
      name: 'Size (W × H × D)',
      value: '100 × 68 × 26 mm',
    },
    {
      id: 17,
      name: 'Weight with battery and without transducers',
      value: '165 g',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/data.js